import Environments from './environments';
export default Environments.production;
